import React, { useState } from "react";
import PropTypes from "prop-types";

import styles from "../styles/accordion-item.module.css";
import { Heading } from "../../heading/src/Heading";

export const AccordionItem = ({
  title,
  children,
  isOpen,
  titleOnClickHandler,
  contentId,
  animationTimeInMilliseconds,
  headingElement,
  headingSizing,
}) => {
  const [contentHeight, setContentHeight] = useState(() =>
    isOpen ? "auto" : "0px"
  );

  const contentWrapperStyles = () => ({
    height: isOpen ? contentHeight : "0px",
    visibility: isOpen ? "visible" : "hidden",
  });

  return (
    <div
      className={isOpen ? styles.open : ""}
      style={{
        "--accordion-animation-time": `${animationTimeInMilliseconds}ms`,
      }}
    >
      <Heading
        className={styles.title}
        domElement={headingElement}
        sizing={headingSizing}
      >
        <button
          className={styles.titleBtn}
          onClick={titleOnClickHandler}
          aria-expanded={isOpen}
          aria-controls={contentId}
        >
          {title}
        </button>
      </Heading>
      <div
        className={styles.contentWrapper}
        id={contentId}
        data-testid={contentId}
        style={contentWrapperStyles()}
      >
        <div
          className={styles.content}
          ref={(node) => {
            if (node) {
              setContentHeight(`${node.offsetHeight}px`);
            }
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

AccordionItem.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  titleOnClickHandler: PropTypes.func.isRequired,
  contentId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  animationTimeInMilliseconds: PropTypes.number.isRequired,
  headingElement: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"])
    .isRequired,
  headingSizing: PropTypes.string.isRequired,
};
